import { SearchFirmsStep } from '../components';
import {
  loadFirmsByFcaNumber,
  setContextFirm,
  setCurrentStep,
  setSearchFirmsForm,
} from 'screens/BrokerPortal/screens/Registration/store/actions';
import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';

export default connect(
  (state: RootState) => {
    return {
      form: state.registration.searchFirms.form,
      firms: state.registration.searchFirms.firms,
    };
  },
  { setSearchFirmsForm, loadFirmsByFcaNumber, setContextFirm, setCurrentStep },
)(SearchFirmsStep);
